import React from 'react';
import { FaInstagram,FaStar, FaFacebook  } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const Footer = () => {
      const { t } = useTranslation();

    return (
        <footer className=" bg-rosso text-pesca p-6 md:px-16  ">
            <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-6 text-center md:text-left max-w-screen-2xl mx-auto">
                
                {/* Info Azienda */}
                <div className="flex flex-col text-center">
                    <p>Az. Agr. Beverahills <br />di Bonfanti Giuseppe</p>
                    <p>Via Santuario inferiore 9, Barzago, LC</p>


                </div>

                {/* Contatti */}
                <div className="flex flex-col">
                    <p>Email: <a href="mailto:info@beverahills.it" className="underline hover:text-white transition">info@beverahills.it</a></p>
                    <p>Giuseppe: <a href="tel:+393358347925" className="underline hover:text-white transition">+39 335 834 7925</a></p>
                    <p>Luca: <a href="tel:+393317375660" className="underline hover:text-white transition">+39 331 737 5660</a></p>

                </div>

                <div className="flex flex-col items-center justify-center whitespace-nowrap">
                    <p>{t("footer.recensione")}</p>
                    <a href="https://g.page/r/Cak1xLvqlBXSEBM/review" className="text-2xl hover:text-white transition flex">
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />


                    </a>
                </div>
                {/* Instagram */}
                <div className="flex flex-col items-center justify-center whitespace-nowrap">
                    <p>{t("footer.seguici")}</p>
                    <div className='flex items-center justify-center gap-4'>
                    <a href="https://www.instagram.com/beverahills/" className="text-2xl hover:text-white transition">
                        <FaInstagram />
                    </a>
                    <a href="https://www.facebook.com/profile.php?id=61576018521431" className="text-2xl hover:text-white transition">
                        <FaFacebook />
                    </a>
                    </div>
                    
                </div>

                {/* Logo */}
                <div className="flex justify-center md:justify-end">
                    <img src="/vettoriale-beverahills-beige.svg" alt="logo" className="w-24" />
                </div>
            </div>

            <div className="
    flex flex-col md:flex-row md:items-center md:justify-center 
    text-xs text-center mt-4
    space-y-1 md:space-y-0 md:space-x-3
  ">
  
  {/* 1. Copyright */}
  <p>© {new Date().getFullYear()} {t("footer.diritti")}</p>
  
  {/* Separatore visibile solo su schermi md e superiori */}
  <span className="hidden md:inline">|</span>
  
  {/* 2. Partita IVA */}
  <p>P. IVA: 02276940133 - CF: BNFGPP69L12G009I</p>
  
  {/* Separatore visibile solo su schermi md e superiori */}
  <span className="hidden md:inline">|</span>
  
  {/* 3. Link Privacy & Cookie */}
  <p>
    <a href="/privacy" className="hover:underline">{t("footer.privacy")}</a>
    <span className="mx-2">|</span>
    <a href="/cookie" className="hover:underline">{t("footer.cookie")}</a>
  </p>

</div>

        </footer>
    );
};

export default Footer;
